/* Physical crop of generated filled M/L/Q/Z artwork. No mask/clipPath is
 * required by the exported SVG. Original artwork remains immutable.
 * Quadratic intersections are solved analytically; surviving curves retain
 * their geometry. Compound paths keep even/odd holes, including edge holes.
 * Filled engraving only: boundary bridges are not intended as laser routes.
 * Photo-product default is the exact physical face, without a safety inset.
 */
(function(root){'use strict';
 const EPS=1e-8;let lastSvg=null,lastParsed=null;
 const near=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y)<EPS;
 const point=(x,y)=>({x,y});
 function surface(shape,options={}){
  const square=shape==='carree',width=square?130:120,height=square?130:100,margin=Number(options.margin??0);
  if(!Number.isFinite(margin)||margin<0||margin>=Math.min(width,height)/2)throw Error('Marge de gravure invalide.');
  const outer=square?[[0,0],[width,0],[width,height],[0,height]]:[[width/4,0],[3*width/4,0],[width,height/2],[3*width/4,height],[width/4,height],[0,height/2]];
  const planes=outer.map((p,i)=>{const q=outer[(i+1)%outer.length],dx=q[0]-p[0],dy=q[1]-p[1],length=Math.hypot(dx,dy),a=-dy/length,b=dx/length;return {a,b,c:-a*p[0]-b*p[1]-margin};});
  const polygon=planes.map((q,i)=>{const p=planes[(i+planes.length-1)%planes.length],det=p.a*q.b-q.a*p.b;return [(p.b*q.c-q.b*p.c)/det,(q.a*p.c-p.a*q.c)/det];});
  return {width,height,margin,polygon,planes};
 }
 function parse(svg){
  if(svg===lastSvg)return lastParsed;
  if(typeof svg!=='string'||svg.length>2000000)throw Error('Dessin SVG non pris en charge.');
  if(/\btransform\s*=|<(?!\/?(?:svg|path)\b)[A-Za-z]/i.test(svg))throw Error('Le recadrage attend les contours du dessin original.');
  const box=/\bviewBox\s*=\s*["']([^"']+)["']/i.exec(svg),view=box?box[1].trim().split(/[\s,]+/).map(Number):[];
  if(view.length!==4||!view.every(Number.isFinite)||view[2]<=0||view[3]<=0)throw Error('Dimensions du dessin SVG invalides.');
  const groups=[];
  for(const tag of svg.matchAll(/<path\b[^>]*>/gi)){
   const attr=/\bd\s*=\s*(["'])(.*?)\1/s.exec(tag[0]);if(!attr)continue;
   const d=attr[2],re=/[MLQZ]|[-+]?(?:\d*\.\d+|\d+\.?\d*)(?:[eE][-+]?\d+)?/g,tokens=d.match(re)||[];
   if(d.replace(re,'').replace(/[\s,]/g,''))throw Error('Ce dessin utilise un type de courbe non pris en charge.');
   let i=0,cmd='',start=null,current=null,segments=[],contours=[];
   function number(){const t=tokens[i++],v=Number(t);if(t===undefined||/[MLQZ]/.test(t)||!Number.isFinite(v))throw Error('Contour SVG incomplet.');return v;}
   function finish(){if(!start)return;if(segments.length&&!near(current,start))segments.push({type:'L',p0:current,p2:start});if(segments.length)contours.push(segments);segments=[];start=null;current=null;}
   while(i<tokens.length){
    if(/^[MLQZ]$/.test(tokens[i]))cmd=tokens[i++];
    if(cmd==='M'){finish();current=start=point(number(),number());cmd='L';}
    else if(cmd==='L'){if(!current)throw Error('Contour SVG sans départ.');const end=point(number(),number());segments.push({type:'L',p0:current,p2:end});current=end;}
    else if(cmd==='Q'){if(!current)throw Error('Contour SVG sans départ.');const control=point(number(),number()),end=point(number(),number());segments.push({type:'Q',p0:current,p1:control,p2:end});current=end;}
    else if(cmd==='Z'){finish();cmd='';}
    else throw Error('Contour SVG incomplet.');
   }
   finish();if(contours.length)groups.push(contours);
  }
  const parsed={view,groups};lastSvg=svg;lastParsed=parsed;return parsed;
 }
 function evaluate(s,t){const u=1-t;return s.type==='L'?point(u*s.p0.x+t*s.p2.x,u*s.p0.y+t*s.p2.y):point(u*u*s.p0.x+2*u*t*s.p1.x+t*t*s.p2.x,u*u*s.p0.y+2*u*t*s.p1.y+t*t*s.p2.y);}
 function interval(s,t0,t1){
  if(t0===0&&t1===1)return s;
  const p0=evaluate(s,t0),p2=evaluate(s,t1);if(s.type==='L')return {type:'L',p0,p2};
  const dt=t1-t0,p1=point(p0.x+dt*((1-t0)*(s.p1.x-s.p0.x)+t0*(s.p2.x-s.p1.x)),p0.y+dt*((1-t0)*(s.p1.y-s.p0.y)+t0*(s.p2.y-s.p1.y)));
  return {type:'Q',p0,p1,p2};
 }
 const distance=(plane,p)=>plane.a*p.x+plane.b*p.y+plane.c;
 function intersections(s,plane){
  const f0=distance(plane,s.p0),f2=distance(plane,s.p2),f1=s.type==='Q'?distance(plane,s.p1):(f0+f2)/2,a=f0-2*f1+f2,b=2*(f1-f0),c=f0;
  let roots=[];
  if(Math.abs(a)<1e-12){if(Math.abs(b)>1e-12)roots=[-c/b];}
  else{let disc=b*b-4*a*c;const tol=1e-12*(b*b+Math.abs(4*a*c)+1);if(disc>=-tol){disc=Math.sqrt(Math.max(0,disc));const q=-.5*(b+(b<0?-disc:disc));roots=Math.abs(q)<1e-15?[-b/(2*a)]:[q/a,c/q];}}
  return roots.filter(t=>Number.isFinite(t)&&t>1e-10&&t<1-1e-10).sort((x,y)=>x-y).filter((t,i,a)=>!i||t-a[i-1]>1e-10);
 }
 function cut(contour,plane,state){
  const pieces=[];
  for(const s of contour){const stops=[0,...intersections(s,plane),1];for(let i=1;i<stops.length;i++){
   const a=stops[i-1],b=stops[i];if(distance(plane,evaluate(s,(a+b)/2))>=-EPS)pieces.push(interval(s,a,b));else state.clipped=true;
  }}
  if(!pieces.length)return [];
  const joined=[];let previous=pieces[pieces.length-1].p2;
  for(const s of pieces){if(!near(previous,s.p0))joined.push({type:'L',p0:previous,p2:s.p0});joined.push(s);previous=s.p2;}
  return joined;
 }
 function extrema(s){
  const pts=[s.p0,s.p2];if(s.type==='Q')for(const axis of ['x','y']){const denominator=s.p0[axis]-2*s.p1[axis]+s.p2[axis];if(Math.abs(denominator)>1e-12){const t=(s.p0[axis]-s.p1[axis])/denominator;if(t>0&&t<1)pts.push(evaluate(s,t));}}return pts;
 }
 function signedArea(contour){
  const cross=(a,b)=>a.x*b.y-a.y*b.x;let twiceArea=0;
  for(const s of contour){if(s.type==='L')twiceArea+=cross(s.p0,s.p2);else{const b=point(2*(s.p1.x-s.p0.x),2*(s.p1.y-s.p0.y)),c=point(s.p0.x-2*s.p1.x+s.p2.x,s.p0.y-2*s.p1.y+s.p2.y);twiceArea+=cross(s.p0,b)+cross(s.p0,c)+cross(b,c)/3;}}
  return twiceArea/2;
 }
 function crop(svg,element,shape,options={}){
  const parsed=parse(svg),area=surface(shape,options),{width:W,height:H}=area,view=parsed.view;
  const size=Number(element.size),x=Number(element.x),y=Number(element.y);
  if(![size,x,y].every(Number.isFinite)||size<=0)throw Error('Position du dessin invalide.');
  const scale=size*1.2/Math.max(view[2],view[3]),cx=view[0]+view[2]/2,cy=view[1]+view[3]/2;
  const transform=p=>point((p.x-cx)*scale+x*W,(p.y-cy)*scale+y*H),state={clipped:false},groups=[];let paths=0,points=0,minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
  const n=v=>String(Math.round(v*1e4)/1e4),coord=p=>n(p.x)+' '+n(p.y);
  for(const group of parsed.groups){let d='';for(const contour of group){
   let result=contour.map(s=>({type:s.type,p0:transform(s.p0),...(s.p1?{p1:transform(s.p1)}:{}),p2:transform(s.p2)}));
   for(const plane of area.planes){result=cut(result,plane,state);if(!result.length)break;}
   if(!result.length)continue;
   let loX=Infinity,hiX=-Infinity,loY=Infinity,hiY=-Infinity;for(const s of result)for(const p of extrema(s)){loX=Math.min(loX,p.x);hiX=Math.max(hiX,p.x);loY=Math.min(loY,p.y);hiY=Math.max(hiY,p.y);}
   // Contacts with an edge or a single vertex have no engravable area.
   if(hiX-loX<EPS||hiY-loY<EPS||Math.abs(signedArea(result))<1e-10)continue;
   paths++;points+=result.length;minX=Math.min(minX,loX);minY=Math.min(minY,loY);maxX=Math.max(maxX,hiX);maxY=Math.max(maxY,hiY);
   d+='M'+coord(result[0].p0);for(const s of result)d+=s.type+(s.type==='Q'?coord(s.p1)+' ':'')+coord(s.p2);d+='Z';
  }if(d)groups.push('<path d="'+d+'"/>');}
  const output='<svg xmlns="http://www.w3.org/2000/svg" width="'+W+'mm" height="'+H+'mm" viewBox="0 0 '+W+' '+H+'" fill="#4a2616" fill-rule="evenodd" stroke="none">'+groups.join('')+'</svg>';
  return {svg:output,viewBox:[0,0,W,H],placement:{x:.5,y:.5,size:Math.max(W,H)/1.2},physical:{width:W,height:H},polygon:area.polygon,paths,points,bounds:paths?{minX,minY,maxX,maxY}:null,clipped:state.clipped};
 }
 const api={crop,surface};if(typeof module==='object'&&module.exports)module.exports=api;else root.PhotoCrop=api;
})(typeof window==='object'?window:this);
